import React from 'react';

import PlatformSendingStatusAlert from '@dashboard/components/PlatformSendingStatusAlert';

import NavigationBar from './NavigationBar';
import useInitialValues from './useInitialValues';
import WaypointTemplateForm from './WaypointTemplateForm';

export default function WaypointTemplateEdit() {
  const initialValues = useInitialValues();
  if (initialValues === null) {
    return <NavigationBar disabled />;
  }
  return (
    <>
      <PlatformSendingStatusAlert />
      <NavigationBar />
      <WaypointTemplateForm initialValues={initialValues} />
    </>
  );
}
